import { PrescriptionSource } from "common/models/types";

/** 처방 입력 경로(source) 별 아이콘/라벨 매핑. 세 컴포넌트에서 공통 사용. */
export const SOURCE_ICON: Record<PrescriptionSource, { name: string; label: string }> = {
  manual: { name: "Edit 01", label: "직접입력" },
  excel: { name: "Document", label: "엑셀" },
  ocr: { name: "Camera", label: "촬영/OCR" },
  nhis: { name: "Building Filled", label: "심평원" },
  identification: { name: "Image Check", label: "식별" },
};
